import { RootState } from '@checkout/state';
import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LoginForm, PasswordRecoveryForm } from '..';
import { logOutRequest, resetErrors, resetNotifications } from '../../../reducers/checkout';
import * as Styles from './LoginWrapper.scss';

interface IOwnProps {
  isFolded: boolean;
}

interface IConnectedProps {}

interface IConnectetDispatchProps {
  logOutRequest: typeof logOutRequest;
  resetNotifications: typeof resetNotifications;
  resetErrors: typeof resetErrors;
}

interface IOwnState {
  active: 'login' | 'recover';
}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps;

class LoginWrapper extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    active: 'login',
  };

  componentDidUpdate() {
    if (this.props.isFolded && this.state.active === 'recover') {
      this.setState({ active: 'login' });
    }
  }

  toggleVisibility = () => {
    this.setState({
      active: this.state.active === 'login' ? 'recover' : 'login',
    }, () => {
      this.props.resetErrors();
      this.props.resetNotifications();
    });
  }

  logout = () => {
    this.props.logOutRequest();
  }

  render() {
    const { isFolded } = this.props;
    const { active } = this.state;

    return (
      <div className={Styles.forms}>
        {active === 'login' && <LoginForm isFolded={isFolded} toggleVisibility={this.toggleVisibility} />}
        {active === 'recover' && <PasswordRecoveryForm isFolded={isFolded} toggleVisibility={this.toggleVisibility} />}
      </div>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {
      logOutRequest,
      resetNotifications,
      resetErrors,
    },
  )
)(LoginWrapper);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/LoginWrapper/LoginWrapper.tsx